import * as React from 'react'

// Mirrors the real PlanPickerPage layout so the page doesn't shift when data
// arrives. Six card placeholders match the six configured plans; if Stripe
// returns fewer (e.g. only one product wired up) the extras unmount cleanly.
export const PlanPickerSkeleton: React.FC = () => {
  return (
    <div className="tw-bg-content-primary tw-min-h-screen tw-py-8 tw-px-4">
      <div className="tw-max-w-5xl tw-mx-auto tw-bg-white tw-border tw-border-base-300 tw-rounded-lg tw-p-8 tw-animate-pulse">
        <div className="tw-h-7 tw-w-48 tw-bg-base-200 tw-rounded tw-mb-3" />
        <div className="tw-h-4 tw-w-96 tw-max-w-full tw-bg-base-200 tw-rounded tw-mb-8" />

        <div className="tw-h-12 tw-w-full tw-bg-base-200 tw-rounded-lg tw-mb-4" />
        <div className="tw-h-12 tw-w-full tw-bg-base-200 tw-rounded-lg tw-mb-8" />

        <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4 tw-mb-8">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="tw-h-44 tw-bg-base-200 tw-rounded-lg" />
          ))}
        </div>

        <div className="tw-flex tw-justify-between tw-items-center">
          <div className="tw-h-6 tw-w-64 tw-bg-base-200 tw-rounded" />
          <div className="tw-h-11 tw-w-40 tw-bg-base-200 tw-rounded-lg" />
        </div>
      </div>
    </div>
  )
}
